import Vue from 'vue'

export default {
  getGiftCard () {
    return Vue.prototype.$http.get(`/gift_cards`)
  },

  updateGiftCard (giftCardId, formData) {
    return Vue.prototype.$http.put(`/gift_cards/${giftCardId}`, formData)
  },

  createGiftCard (formData) {
    return Vue.prototype.$http.post('/gift_cards', formData)
  },

  getPurchases () {
    return Vue.prototype.$http.get('/gift_cards/purchases')
  }
}
